// extracted by mini-css-extract-plugin
export default {"selectcategory":"style_selectcategory__PJf8n","required":"style_required__ND-J6"};